import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'spv2-no-access-to-feature',
    templateUrl: './no-access-to-feature.component.html',
    styleUrls: ['./no-access-to-feature.component.scss'],
    standalone: false
})
export class NoAccessToFeatureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
